var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDgInH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_284",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.6 20.6",
    style: {
      enableBackground: "new 0 0 31.6 20.6"
    },
    xmlSpace: "preserve",
    width: 24.536,
    height: 27.575,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BFC6D8;}\n\t.st1{fill:#A2AABA;}\n\t.st2{opacity:0.8;enable-background:new    ;}\n\t.st3{fill:#EBEDF2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_217-2_00000158750966198004730330000014788062710543089817_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,0.6l0,19.2c0,0.4-0.3,0.7-0.6,0.7L0.7,20.6c-0.3,0-0.6-0.3-0.6-0.7L0,0.7C0,0.3,0.3,0,0.6,0L30.9,0 C31.3,0,31.5,0.3,31.5,0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_218-2_00000015333923973310068660000013383021735172142466_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.4,1.4l0,17.6c0,0.2-0.2,0.4-0.4,0.4h0l0,0L1.4,19.4c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0l0,0l0-17.6 C0.9,1.2,1.1,1,1.3,1l0,0L30,0.9C30.2,0.9,30.4,1.1,30.4,1.4C30.4,1.4,30.4,1.4,30.4,1.4L30.4,1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_230_00000057134043738045125440000011959005267756296086_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.6,2.4l0,15.6c0,0.1-0.1,0.2-0.2,0.2l0,0l0,0L2.1,18.2l0-15.8c0-0.1,0.1-0.2,0.2-0.2l0,0l27.1-0.1 C29.5,2.1,29.6,2.2,29.6,2.4L29.6,2.4z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.4,16.3h-1.8v-5.5h-3.4v5.5h-1.8V4.2h1.8v5h3.4v-5h1.8V16.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgInH);
export default __webpack_public_path__ + "static/media/dg-in-h.54a0b77727687f1488110fe16ca28d4a.svg";
export { ForwardRef as ReactComponent };